import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CandidateProgress } from './../model/model';

// Avoid name not found warnings
@Injectable()
export class CandidateProgressService {
    public queryEndPoint = 'query-api/CandidateProgress';

    constructor(private http: HttpClient) { }

    public get = (candidateId: string) => this.http.get<CandidateProgress>(`${this.queryEndPoint}/${candidateId}`);
}
